// The Lookups (LK1) Account "type" code for nominal ledger accounts —
// Osprey.Lookups.Api's AccountController.ValidAccountTypes is B|D|J|N|P; 'N' is Nominal.
// Named here (not inlined at the call site) so the nominal-picker account-type filter is
// a single, greppable source of truth.
export const NOMINAL_ACCOUNT_TYPE = 'N'

// Historically Osprey1 identified ALL fee income via one hard-coded ledger journal name,
// 'FEES JNL' (see Osprey.Accounts.Api/planning/calc-spike-findings.md — the accruals
// income calc was cross-checked against the live ReportProfitAndLoss/ReportProfitAndLoss2
// procs, which key off `journalName1 = 'FEES JNL'`). A `SourceType: 'Fee'` mapping is the
// direct successor to that legacy value: it is not read from the ledger by nominal code at
// all, it stands in for the whole of fee income. Kept here as a single named config
// constant — never re-hard-code the literal 'FEES JNL' elsewhere in the UI.
export const LEGACY_FEE_SOURCE_LABEL = 'FEES JNL'
